import React, { PureComponent } from 'react';
import {
  StyleSheet, View, Text,
  SafeAreaView,
} from 'react-native';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { defaultScale } from '../../../../utils/scaling';
import { getNextStep, navigateToNextStep } from '../../../actions';
import { IAppStore } from '../../../../HomeWorkouts';
import { GoogleAnalytics } from '../../../../services/google-analytics';
import Theme from '../../../../theme';
import { UserDataConsumer } from '../../../../utils';
import GreenCheckMark from '../../../../assets/icons/check-circle-green.svg';
import { IConnectedAppOnboardingProps, navigateToNextOnboardingStep } from '../ConnectedAppEntryPointScreen';
import AppleWatchWorkoutIcon from '../../../../assets/icons/connected-apps/apple-watch-workout.svg';
import AppleWatchHeartIcon from '../../../../assets/icons/connected-apps/apple-watch-heartrate.svg';
import FooterButtons from '../shared/FooterButtons';
import { IAppForOnboarding } from '../../../../ConnectedApps';
import MultiStyleText from '../../../../ui/components/MultiStyleText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
  },
  headerContainer: {
    alignItems: 'center',
    marginTop: '10%',
    textAlign: 'center',
    flex: 1,
  },
  heading: {
    textAlign: 'center',
    color: Theme.GREEN,
    marginLeft: defaultScale(10),
  },
  textLeft: {
    textAlign: 'left',
  },
  textRight: {
    textAlign: 'right',
  },
  appleWatchIcons: {
    width: '100%',
    paddingHorizontal: defaultScale(16),
  },
  iconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: defaultScale(10),
    padding: defaultScale(10),
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  iconRight: {
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
  },
  iconLeft: {
    alignSelf: 'flex-start',
    justifyContent: 'flex-start',
  },
  textStyle: {
    marginHorizontal: defaultScale(10),
    flex: 1,
    flexWrap: 'wrap',
    padding: defaultScale(10),
  },
  header: {
    marginTop: defaultScale(10),
    marginBottom: defaultScale(40),
    color: Theme.BLACK,
    paddingHorizontal: defaultScale(10),
    textAlign: 'center',
  },
});

class ConnectAppleWatch extends PureComponent<IConnectedAppOnboardingProps & WithTranslation> {
  private readonly googleAnalytics: GoogleAnalytics;

  private readonly appForOnboarding: IAppForOnboarding = this.props.navigation.getParam('appForOnboarding');

  public constructor(props: IConnectedAppOnboardingProps & WithTranslation) {
    super(props);
    this.googleAnalytics = new GoogleAnalytics();
  }

  public render() {
    const { t } = this.props;

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.headerContainer}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <GreenCheckMark />
            <MultiStyleText
              templateString={t('appEnabled')}
              styleKeys={[
                {
                  keyName: 'connectedApp',
                  keyValue: this.appForOnboarding.app,
                },
              ]}
              normalStyle={{ ...Theme.textStyle.bodyCopyBold, ...styles.heading }}
            />
          </View>
          <Text style={[Theme.textStyle.heading, styles.header]}>{t('getTheMostOutOfYourAppleWatch')}</Text>
          <View style={styles.appleWatchIcons}>
            <View style={[styles.iconContainer, styles.iconRight]}>
              <MultiStyleText
                templateString={t('appleHealthWatchActivity')}
                styleKeys={[
                  {
                    keyName: 'automaticallySync',
                    keyValue: 'automatically sync',
                    style: { ...Theme.textStyle.bodyCopyBold, ...styles.textStyle },
                  },
                ]}
                normalStyle={{ ...Theme.textStyle.bodyCopyReg, ...styles.textStyle }}
              />
              <AppleWatchWorkoutIcon />
            </View>
            <View style={[styles.iconContainer, styles.iconLeft]}>
              <AppleWatchHeartIcon />
              <MultiStyleText
                templateString={t('appleHealthWatchHeartRate')}
                styleKeys={[
                  {
                    keyName: 'companionApp',
                    keyValue: 'companion app',
                    style: { ...Theme.textStyle.bodyCopyBold, ...styles.textStyle },
                  },
                ]}
                normalStyle={{ ...Theme.textStyle.bodyCopyReg, ...styles.textStyle }}
              />
            </View>
          </View>
        </View>
        <FooterButtons
          primaryButtonText={t('next')}
          onPrimaryButtonPress={() => this.proceedToNextStep()}
          isLoading={false}
        />
      </SafeAreaView>
    );
  }

  private proceedToNextStep = () => {
    const appForOnboarding = this.props.navigation.getParam('appForOnboarding') as IAppForOnboarding;
    if (appForOnboarding.isAppInstalledOnConnectedDevice) {
      navigateToNextOnboardingStep(
        this.props,
        this.props.getNextStep,
        this.props.navigateToNextStep,
      );
    } else {
      this.props.navigation.navigate('InstallWatchCompanionApp');
    }
    this.googleAnalytics.logEventWithParamaters('sign_up_connect_apple_watch', { enabled: true });
  };
}

const mapStateToProps = (state: IAppStore) => ({
  enabledFeatures: state.auth.signup.enabledFeatures,
});

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export default withTranslation(['auth', 'settings'])(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(ConnectAppleWatch)),
);
